export const GET_MENU_INFO = "MENU_GET_INFO";
export const RESET_MENU_STATE = "RESET_MENU_STATE";
